/**
 * @file page entry
 * @author liuweijian01<luohuixiang@baidu.com>
 */

import 'babel-polyfill';
import Vue from 'vue';
import 'vue-photo-preview/dist/skin.css';
import Loading from '@/directives/loading.js';
import logger from '@/plugins/logger';
import preview from 'vue-photo-preview';
import {performanceMonitor} from '@/utils/browser';
import App from './app.vue';
import VueLazyload from 'vue-lazyload';
import {getUserAgentInfo} from '@/utils/browser-info';
import {getFormatCookie} from '@/utils/experiment';
import {getQueryString} from '@/utils/url';
import NumberFilter from '@/plugins/numberFilter';
import CompositionApi from '@vue/composition-api';


import initWeirwood from '@/utils/weirwood';
const formatCookie = getFormatCookie();

Vue.use(logger, {
    from: 'Mini_Swan_game',
    page: 'strategyPage',
    inBox: 0,
    network: navigator.connection ? navigator.connection.effectiveType || '' : '',
    styleInfo: formatCookie.GAME_SID_KEY || '',
    source: getQueryString('channelid') || '',
});

window.detailUserAgentInfo = getUserAgentInfo();

Vue.use(Loading);
Vue.use(VueLazyload);
Vue.use(CompositionApi);


Vue.use(preview, {
    tapToClose: true,
    fullscreenEl: false,
});
Vue.use(NumberFilter);

initWeirwood(Vue); // 初始化weirwood
window.onload = function () {
    performanceMonitor('13_96', 'gamepage_strategy');
};

document.title = '百度游戏';

new Vue({
    data() {
        return {
            videoView: [],
            extData: {},
        };
    },
    render: h => h(App),
}).$mount('#app');
